import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
var PassGuard = /** @class */ (function () {
    function PassGuard(router) {
        this.router = router;
    }
    PassGuard.prototype.canActivate = function (route, state) {
        if (localStorage.getItem('currentUser')) {
            var user = JSOG.parse(localStorage.getItem('currentUser'));
            // 仮パスワード発行＋変更前
            if (user && user['isTemporaryPass']) {
                this.router.navigate(['/password']);
                return false;
            }
        }
        return true;
    };
    PassGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PassGuard.ctorParameters = function () { return [
        { type: Router }
    ]; };
    return PassGuard;
}());
export { PassGuard };
//# sourceMappingURL=pass.guard.js.map